import React, { useEffect, useRef, useState } from 'react';
import { RouteComponentProps } from '@reach/router';
import { TrashCan } from '../../components/Icons';
import Table from '../../components/Table';
import { domain } from '../../d-man';
import Pager from '../../components/Pager';
import { useGetMaterials } from '../../queries/Materials';
import { useCurrentProjectId } from '../../queries/Accounts';
import { useGetPermissions } from '../../queries/Permissions';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function Materials(props: RouteComponentProps) {
    const PAGE_SIZE = 30;
    const [skip, setSkip] = useState(0);
    const materials = useGetMaterials(skip, PAGE_SIZE);
    const materialsRef = useRef(materials);

    const projectId = useCurrentProjectId();
    const getPermissions = useGetPermissions('PROJECT', projectId.data);
    const { navigate } = props;
    // REDIRECT IF NOT CORRECT ROLE
    if (
        getPermissions.data &&
        !getPermissions.data?.items.find((p) => p.code === 'Project_Allow_Admin')?.hasAccess &&
        navigate
    ) {
        navigate(`/`);
    }

    useEffect(() => {
        materialsRef.current.reset();
    }, [materialsRef]);

    /**
     * Does an HTTP Delete to the server for the specified id
     * @param id
     */
    const deleteMaterial = async (id?: string) => {
        const remove = domain.delete(`/materials/${id}`);
        await remove.execute();
        materials.reset();
    };

    const handleNextPage = () => {
        setSkip(skip + PAGE_SIZE);
        materials.reset();
    };

    const handlePreviousPage = () => {
        setSkip(Math.max(skip - PAGE_SIZE, 0));
        materials.reset();
    };

    return (
        <div className="flex flex-col w-full">
            <div className="m-4">
                <Table<{ id: string; description: string }>
                    loading={materials.loading && 'Fetching Materials from server'}
                    error={
                        materials.error &&
                        `Failed to fetch Materials list from the server (${materials.error})`
                    }
                    data={materials.data?.items}
                    columns={[
                        {
                            key: 'description',
                            title: 'Description',
                        },
                        {
                            key: 'actions',
                            title: '',
                            render: (unit) => (
                                <TrashCan
                                    className="cursor-pointer flex"
                                    id={unit.id}
                                    onClick={() => deleteMaterial(unit.id)}
                                />
                            ),
                        },
                    ]}
                />
                {materials.data && materials.data.totalCount > PAGE_SIZE && (
                    <Pager
                        onNextPage={handleNextPage}
                        onPreviousPage={handlePreviousPage}
                        skip={skip}
                        pageSize={PAGE_SIZE}
                        objectList={materials.data}
                    />
                )}
            </div>
        </div>
    );
}
